// Estadias mensalistas (acima de 26 noites) tem condominio, IPTU, limpezas e pacote
// embutidos no valor da reserva. Esses itens sao tratados em contrato com o proprietario
// (podem ser dedutiveis de IR) e nao entram nos relatorios, entao o site so os detalha
// a partir desta quantidade de noites. Abaixo disso, mostra um valor unico.
export const MIN_NIGHTS_TO_SHOW_FEE_BREAKDOWN = 90

// Numero de limpezas que o back-site considera no total de uma reserva mensalista
// (payment/index.ts: cleaning_value = service.price * 5). Usado para recuperar o valor
// unitario da limpeza na tela remontada pelo codigo PIX, que so recebe o total.
export const MONTHLY_CLEANINGS_COUNT_IN_BACKEND = 5

export const shouldShowFeeBreakdown = (nights: number): boolean => {
    return nights >= MIN_NIGHTS_TO_SHOW_FEE_BREAKDOWN
}

interface MonthlyFeesInput {
    midStay: number
    condominium: number
    iptu: number
    yoghaPackage: number
    cleaningUnit: number
    cleanings: number
}

// Sem o detalhamento, a limpeza final (sempre existe numa reserva mensal) aparece em linha
// propria e as demais limpezas entram no aluguel. rent + finalCleaning = total anterior.
export const splitMonthlyFees = ({ midStay, condominium, iptu, yoghaPackage, cleaningUnit, cleanings }: MonthlyFeesInput) => {
    const finalCleaning = cleanings > 0 ? cleaningUnit : 0
    const extraCleanings = Math.max(cleanings - 1, 0)
    const rent = midStay + condominium + iptu + yoghaPackage + (extraCleanings * cleaningUnit)

    return { rent, finalCleaning }
}
